import { render, staticRenderFns } from "./BaseAccordionItem.vue?vue&type=template&id=2ba4cbdf&scoped=true&"
import script from "./BaseAccordionItem.vue?vue&type=script&lang=js&"
export * from "./BaseAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccordionItem.vue?vue&type=style&index=0&id=2ba4cbdf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba4cbdf",
  null
  
)

export default component.exports